import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpXhrBackend } from '@angular/common/http';
declare var $;

export class ApiMethod {
  static appConfigUrl = '/assets/app-config.json';
  static basePath: string = $('base')[0].href;
  constructor() {
    ApiMethod.getBaseUrl();
  }
  static getPageConfig() {
    return this.http.get(this.appConfigUrl);
  }

  static getBaseUrl(): void {
    this.http.get<any>(this.appConfigUrl)
      .toPromise()
      .then(data => {
        localStorage.AppName = data["ProjectName"];
      });
  }

  static http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
  static getMethod(apiUrl): Observable<any> {
    let headers = {
      headers: { 'Access-Control-Allow-Origin': '*', 'ClientApiUrl': apiUrl }
    };
    return this.http.get<any>(this.basePath + 'api/Endpoint/GetClient', headers);
  }

  static postMethod(apiUrl, itemData): Observable<any> {
    let headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('ClientApiUrl', apiUrl);
    let aitemP = JSON.stringify(itemData);
    return this.http.post(this.basePath + 'api/Endpoint/PostClient', aitemP, { headers: headers });
  }

  static FilePostMethod(apiUrl: string, itemData: any): Observable<any> {

    let headers = new HttpHeaders()
      .set('ClientApiUrl', apiUrl);   // ✅ keep custom header

    // ✅ DO NOT stringify
    // ✅ DO NOT set content-type

    return this.http.post(
      this.basePath + 'api/Endpoint/PostClient',
      itemData,                      // FormData goes as-is
      { headers: headers }
    );
  }


  static postFileMethod(apiUrl, file): Observable<any> {
    let headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('ClientApiUrl', apiUrl);
    let aitemP = JSON.stringify(file);
    return this.http.post(this.basePath + 'api/Endpoint/PostFileClient', aitemP, { headers: headers });
  }

  static postFileMethod1(apiUrl: string, formData: FormData): Observable<any> {
    formData.append('ClientApiUrl', apiUrl);    
    return this.http.post(this.basePath + 'api/Endpoint/PostFileClientUpdated', formData);
  }

  static mywindow = null;

  public static Downloadfile(apiUrl) {
    let headers = {
      headers: { 'Access-Control-Allow-Origin': '*', 'ClientApiUrl': apiUrl }
    };
    if (apiUrl.indexOf('undefined') == -1) {
      return this.http.get<any>(this.basePath + 'api/Endpoint/GetApiUrl', headers).subscribe(
        response => {
          if ((this.mywindow != null)) {
            this.mywindow.close();
          }
          let downloadUrl = response["endpoint"].toString();
          //window.open(downloadUrl, "_self");
          this.mywindow = window.open(downloadUrl, "mywindow", "location=1,status=1,scrollbars=1,  width=500,height=200");
          this.mywindow.moveTo(500, 100);

        });
    }
  }

  public static MultipleFileDownload(apiUrl, idList) {
    let idlist = idList.replace(",", "_");
    let endpoint = this.basePath + 'api/Endpoint/GetApiUrl/';
    let headers = {
      headers: { 'Access-Control-Allow-Origin': '*', 'ClientApiUrl': apiUrl + idlist }
    };
    if (apiUrl.indexOf('undefined') == -1) {
      return ApiMethod.http.get<any>(endpoint, headers).subscribe(
        response => {
          if ((this.mywindow != null)) {
            this.mywindow.close();
          }
          let downloadUrl = response["endpoint"].toString();
          this.mywindow = window.open(downloadUrl, "mywindow", "location=1,status=1,scrollbars=1,  width=500,height=200");
          this.mywindow.moveTo(500, 100);
        });
    }
  }

  static getMenuUrl() {
    try {
      if (localStorage.aLoginID != null) {
        let menuFile = localStorage.aLoginID + 'menu.json';
        this.http.get<any>('/asset/Resource/Menus/' + menuFile)
          .toPromise()
          .then(data => {
            let itemL = data;
            console.log(itemL);
          });
      }
    } catch (e) {
    }
  }
}
